import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_GP_TO_COST_REPORT } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const gpToCostReport = {
  namespaced: true,
  state: buildInitialState({
    gpVSCostItems: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearGpVSCostItems: (state) => {
      state.gpVSCostItems = []
    },
    setGpVSCostItems: (state, gpVSCostItems) => {
      state.gpVSCostItems = gpVSCostItems
    }
  },
  actions: {
    getGpVSCostItems: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting GP vs Cost data, please wait...' })

      return api.doGet({ path: PATH_GP_TO_COST_REPORT, parameters: filters })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setGpVSCostItems', data)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get GP vs Cost data')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getFieldsWithFilters: ({ dispatch, rootGetters }) => {
      return dispatch('getGpVSCostItems', { ...rootGetters['gpToCostReportFilters/getSearchObject'] })
    }
  }
}

export default gpToCostReport
